import { marketService, ssoService, appService } from "./app";

export const createCardUpdaturl = (data) => {
  return appService.post("/member/v1/3ds/create-card-update-url", data);
}

export const get3dsCard = (data) => {
  return appService.post("/member/v1/3ds/get-card", data);
}
